export const GLOBAL_ERROR_DIAGNOSTIC_MESSAGE =
  "Diagnóstico: erro forçado intencionalmente para testar o global-error boundary.";
